export enum TressExceptions {
  ChangeReset_InvalidMailAddress,
  ChangeReset_InvalidPassword,
  ChangeReset_PasswordsMustMatch,
  ChangeReset_UserNotLoggedIn,
  FindByCustomerNumber_MissingCustomerNumber,
  InvalidMailAddress,
  PasswordForgot_InvalidMailAddress,
  PasswordReset_InvalidMailAddress,
  PasswordReset_InvalidPassword,
  PasswordReset_MissingToken,
  Register_AlreadyLoggedIn,
  Register_EmailAlreadyExists,
  Register_InvalidMailAddress,
  Register_InvalidPassword,
  Register_MissingCustomerAddress,
  Register_MissingCustomerCity,
  Register_MissingCustomerEmail,
  Register_MissingCustomerForCustomerNumber,
  Register_MissingCustomerName,
  Register_MissingCustomerPhoneNumber,
  Register_MissingCustomerZip,
  Register_MissingName,
  Register_MissingPhoneNumber,
  Register_PasswordsMustMatch,
  ResetPassword_ResetPasswordFailed,
  SignIn_Error,
  SignIn_MissingPassword,
  SignIn_MissingUsername,
  Unknown_Error,
  Checkout_GetShippingOptions,
  Checkout_NoShippingOptions,
  ChangePassword_InvalidCurrentPassword,
}
